import React, { forwardRef } from 'react';
import { Line } from 'react-chartjs-2';

const DrawdownChart = forwardRef(({ data, colours = {} }, ref) => {
  if (!data || !data.portfolio || data.portfolio.length === 0) {
    return <div className="chart-placeholder">No time series data available</div>;
  }

  const series = data.portfolio;

  let peak = -Infinity;
  const drawdowns = series.map((point) => {
    const val = point.value;
    if (val > peak) peak = val;
    const dd = peak > 0 ? ((val - peak) / peak) * 100 : 0;
    return { date: point.date, drawdown: dd };
  });

  const labels = drawdowns.map(d => d.date);
  const values = drawdowns.map(d => d.drawdown);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Drawdown',
        data: values,
        borderColor: colours.drawdown_line || '#f0a500',
        backgroundColor: (colours.drawdown_line || '#f0a500') + '33',
        fill: true,
        pointRadius: 0,
        borderWidth: 1.5,
        tension: 0.1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: 0 },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `Drawdown: ${ctx.parsed.y.toFixed(2)}%`,
        },
      },
    },
    scales: {
      x: {
        border: { display: false },
        grid: { display: false },
        ticks: {
          font: { size: 10 },
          maxTicksLimit: 8,
          maxRotation: 0,
        },
      },
      y: {
        border: { display: false },
        grid: { color: 'rgba(0,0,0,0.1)' },
        ticks: {
          font: { size: 10 },
          callback: (val) => `${val}%`,
        },
        max: 0,
      },
    },
  };

  return (
    <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
      <Line ref={ref} data={chartData} options={options} />
    </div>
  );
});

DrawdownChart.displayName = 'DrawdownChart';
export default DrawdownChart;
